export default __webpack_public_path__ + "static/media/graph-token-mobi.e91a9728.svg";